import React, { useState, useEffect,useContext } from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton } from "@mui/material";
import ButtonStyle from "components/Button/ButtonStyle.module.css";
import TableAllData from "components/Content/CustomTable/TableAllData";
import TableStyle from "components/Content/Table/TableStyle.module.css";
import { apiGet } from "app/Services/ApiService";
import { apiUrls } from "common/ApiUrls";
import { CloudDownloadOutlined } from "@mui/icons-material";
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import ListAltOutlinedIcon from '@mui/icons-material/ListAltOutlined';
import moment from "moment";
import { PrivateRoutesContext } from "app/PrivateRoutesContext";
import { Utils } from "common/Utils";
import ConfirmDialog from "components/Content/Modal/ConfirmDialog";
import StatusDetailsDialog from "components/Content/Modal/StatusDetailsDialog";
import AximTooltip from "components/AximTooltip";
import SummarizeOutlinedIcon from '@mui/icons-material/SummarizeOutlined';
import ReportRequestDialog from "components/Content/Modal/ReportRequestDialog";

function Reports() {
  const { modalIsOpen, setModalIsOpen, companyId, setCompanyId } = useContext(PrivateRoutesContext);
  const [fetchedData, setFetchedData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [doShowDialog, setDoShowDialog] = useState(false);
  const [dialogTitle, setDialogTitle] = useState("");
  const [dialogText, setDialogText] = useState("");

  const [isReportRequestDialogOpen, setIsReportRequestDialogOpen] = useState(false);
  const [doShowConfirm, setDoShowConfirm] = useState(false);
  const [confirmCloseAction, setConfirmCloseAction] = useState(null);
  const [confirmTitle, setConfirmTitle] = useState('');
  const [confirmText, setConfirmText] = useState('');
  const [confirmButtonsDisabled, setConfirmButtonsDiabled] = useState(false);

  const [doShowStatusDetails, setDoShowStatusDetails] = useState(false);
  const [statusTitle, setStatusTitle] = useState("");
  const [statuses, setStatuses] = useState([]);

  //REPORTSTATUSQUEUE

  const columns = [
    {
      Header: "",
      accessor: "reportQueueId",
      Cell: e =>
        <>
          <AximTooltip title="Download">
            <IconButton onClick={() => promptDownloadReport(`${e.value}`,`${e.row.values.name}`)} color="primary"><CloudDownloadOutlined /></IconButton>
          </AximTooltip>
          <AximTooltip title="Delete">
            <IconButton onClick={() => promptDeleteReport(`${e.value}`)} color="primary"><DeleteOutlineOutlinedIcon /></IconButton>
          </AximTooltip>
        </>
      ,
      maxWidth: 100,
      disableFilters: true,
    },
    {
      Header: "Report Name",
      accessor: "name",
    },
    {
      Header: () => {
        return (
          <>
            Report Status
            <IconButton onClick={showStatuses} className="py-0" color="primary"><ListAltOutlinedIcon /></IconButton>
          </>
        )
      },
      accessor: "status",
    },
    {
      Header: "Create Date",
      accessor: (cell) => Utils.formatDateTime(cell.createDate),
    },
    {
      Header: "Process Date",
      accessor: (cell) => Utils.formatDateTime(cell.processDate),
    },
  ];

  const initialTableState={
    pageIndex: 0, 
    pageSize: 10,
    sortBy: [
        {
            id: 'createDate',
            desc: true
        }
    ]
  }

  useEffect(() => {
    apiGet(apiUrls.getStatuses("REPORTQUEUESTATUS"))
      .then((response) => {
        setStatuses(response.data);
    })
    .catch(function (e) {
        setStatuses([]);
    });
  }, []);

  useEffect(() => {
    getReports();
  }, [companyId]);

  const getReports = () => {
    setIsLoading(true);

    apiGet(apiUrls.getReports(companyId)).then(
      (response) => {
        setFetchedData(response.data);
      }
    )
    .finally(() => {
      setIsLoading(false);
    });
  }

  const handleConfirmClose = (result) => {
    confirmCloseAction(result);
  }

  const promptDownloadReport = (reportQueueId, fileName) => {
    setConfirmCloseAction(() => (result) => downloadReport(result, reportQueueId, fileName));
    setConfirmTitle('Download Report');
    setConfirmText(`Are you sure you would like to download report?`);
    setDoShowConfirm(true);
  }

  const downloadReport = (isConfirmed, reportQueueId, fileName) => {
    if (isConfirmed) {
      setConfirmButtonsDiabled(true);

      Utils.downloadFile(apiUrls.downloadFile(companyId, reportQueueId),
        fileName,
        null,
        () => setMessage("An Error Occurred", "An Error occurred downloading the file."),
        () => {
          setConfirmButtonsDiabled(false);
          setDoShowConfirm(false);
        });
    }
    else {
      setDoShowConfirm(false);
    }
  }

  const promptDeleteReport = (reportQueueId) => {
    setConfirmCloseAction(() => (result) => deleteReport(result, reportQueueId));
    setConfirmTitle('Delete Report');
    setConfirmText(`Are you sure you would like to delete report?`);
    setDoShowConfirm(true);
  }

  const deleteReport = (isConfirmed, reportQueueId) => {
    if (isConfirmed) {
      setConfirmButtonsDiabled(true);

      apiGet(apiUrls.deleteReport(companyId, reportQueueId)).then(
        (response) => {
          if (response.data) {
            getReports();
            setMessage("Report Deleted", "Report has been deleted.")
          }
        }
      ).finally(() => {
        setConfirmButtonsDiabled(false);
        setDoShowConfirm(false);
      });
    }
    else {
      setDoShowConfirm(false);
    }
  }

  const setMessage = (title, text) => {
    setDialogTitle(title);
    setDialogText(text);
    setDoShowDialog(true);
  }

  const handleClose = () => {
    setDoShowDialog(false);
  }
  
  const showStatuses = e => {
    e.stopPropagation();

    setStatusTitle("Report Queue Statuses");
    setDoShowStatusDetails(true);
  }

  return (
    <div>
          <div className={TableStyle.tableWrapper}>
            <TableAllData columns={columns} data={fetchedData} initialState={initialTableState} isLoading={isLoading} />
          </div>
      
      <Dialog
        open={doShowDialog}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{dialogTitle}</DialogTitle>
        <DialogContent>{dialogText}</DialogContent>

        <DialogActions>
          <Button onClick={handleClose} color="primary" variant="outlined">
            Close
          </Button>
        </DialogActions>
      </Dialog>

      <ConfirmDialog
                doShowConfirm={doShowConfirm}
                handleClose={handleConfirmClose}
                confirmTitle={confirmTitle}
                confirmText={confirmText}
                buttonsDisabled={confirmButtonsDisabled} />

    <ReportRequestDialog openModal={isReportRequestDialogOpen} handleClose={() => setIsReportRequestDialogOpen(false)}  />
    </div>
  );
}

export default Reports;
